import _identity from 'lodash/fp/identity'
import _pipe from 'lodash/fp/pipe'
import _tap from 'lodash/fp/tap'

export const tap = _tap

export const identity = _identity

export const pipe = _pipe

export const isOdd = (n) => n % 2

export const pluck = (key) => (object) => object[key]

export const isIntersection =
    ([targetRangeStart, targetRangeEnd]) =>
    ([rangeStart, rangeEnd]) =>
        rangeEnd >= targetRangeStart && rangeStart <= targetRangeEnd
